"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const LanguageSelectionDialog_vue_1 = require("@/client/components/LanguageSelectionDialog.vue");
const constants_1 = require("@/common/constants");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'LanguageIcon',
    components: {
        'language-selection-dialog': LanguageSelectionDialog_vue_1.default,
    },
    data() {
        return {
            languagePanelOpen: false,
        };
    },
    computed: {
        preferencesManager() {
            return PreferencesManager_1.PreferencesManager.INSTANCE;
        },
        lang() {
            return PreferencesManager_1.PreferencesManager.INSTANCE.values().lang;
        },
        title() {
            const lang = constants_1.LANGUAGES[this.lang];
            return `${lang[0]} (${lang[1]})`;
        },
    },
});
